/**
 * A service that wraps the console for ease of enabling / disabling logging.
 *
 * @export
 * @class ConsoleService
 */
var ConsoleService = /** @class */ (function () {
    /**
     * @param  {boolean} isDevMode defaults to true, and will therefore enable all console.log statements.
     */
    function ConsoleService(isDevMode) {
        if (isDevMode === void 0) { isDevMode = true; }
        this.isDevMode = isDevMode;
    }
    /**
     * @param  {string} message The message to be logged.
     */
    ConsoleService.prototype.log = function (message) {
        if (this.isDevMode === true) {
            console.log(message);
        }
    };
    return ConsoleService;
}());
export { ConsoleService };
//# sourceMappingURL=console-service.js.map